<section class="container-fluid clearfix p-0">
  <div class="container-fluid p-0" >
    <app-map-open-data [sedes]="alcaldias_data" [fullData]="fullDato"></app-map-open-data>
  </div>
  <app-map-control [sedes]="alcaldias_data" [fullData]="fullDato"></app-map-control>
</section>
